import {
  UserCredential,
  signOut as firebaseSignOut,
  signInWithEmailAndPassword,
} from 'firebase/auth';

import { roleApi, withAuthHeader } from '@/lib/backend/api';
import { fbAuth } from '@/lib/firebase/init';
import { parseFirebaseError } from '@/lib/firebase/messages/parse-firebase-message';
import { RoleType } from '@addmile/backend-client';

interface SignInResponse {
  user?: UserCredential;
  role?: RoleType;
  error?: boolean;
  errorMessage?: string;
}

class AuthService {
  async signIn(email: string, password: string): Promise<SignInResponse> {
    try {
      const userCredential = await signInWithEmailAndPassword(fbAuth, email, password);

      const token = await userCredential.user.getIdToken();
      this.assignToken(token);
      const { data: role } = await roleApi.getRole(withAuthHeader(token));

      if (!role?.role) {
        await this.signOut();
        return { error: true, errorMessage: 'Role not found, please contact admin' };
      }

      return { error: false, user: userCredential, role: role.role?.type ?? undefined };
    } catch (error) {
      await this.signOut();
      const errorMessage = parseFirebaseError(error);
      return { error: true, errorMessage };
    }
  }

  async signOut() {
    try {
      await firebaseSignOut(fbAuth);
      localStorage.removeItem('firebase-token');
    } catch (error) {
      console.error('Error signing out:', error);
    }
  }

  private assignToken(token: string) {
    localStorage.setItem('firebase-token', token);
  }
}

export const authService = new AuthService();
